import React from 'react';

import './styles.scss';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentPendenciaDemanda from './ContentPendeciaDemanda';

const Pendencias = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentPendenciaDemanda />
      <Bottom />
    </div>
  );
};

export default Pendencias;
